export const GRID_HEIGHT = 300;

export const TITLE_CONTENT = 'Transmit Internal Purchase Order';

export const SUB_TITLE_CONTENT = 'Below internal P/Os have been committed to sale lines due to Internal Transfer fulfillment selection';
